module.exports = __webpack_public_path__ + "static/parade-2019-house09-116639a483ecb076ef6ed43dbac38ff4.jpg";